/** Definições das colunas de métricas (Fase 6), sem imports para evitar ciclos. */

// ---- Colunas de métricas (tabela de campanhas e exportação) ---------------------------------------

export type MetricFormat = "money" | "int" | "pct" | "ratio" | "roas";

/** Chaves de `Metrics` (ver reports-enums.ts); duplicadas aqui para não criar ciclo de import. */
export type MetricKey =
  | "spendCents"
  | "impressions"
  | "reach"
  | "clicks"
  | "linkClicks"
  | "results"
  | "purchases"
  | "purchaseValueCents"
  | "leads"
  | "registrations"
  | "messages"
  | "thruplays"
  | "videoP25"
  | "videoP50"
  | "videoP75"
  | "videoP100"
  | "frequency"
  | "ctr"
  | "linkCtr"
  | "cpcCents"
  | "cpmCents"
  | "costPerResultCents"
  | "costPerLeadCents"
  | "costPerPurchaseCents"
  | "roas";

export interface MetricDef {
  id: MetricKey;
  label: string;
  short: string;
  format: MetricFormat;
}

export const METRIC_DEFS: readonly MetricDef[] = [
  { id: "spendCents", label: "Gasto", short: "Gasto", format: "money" },
  { id: "impressions", label: "Impressões", short: "Impr.", format: "int" },
  { id: "reach", label: "Alcance", short: "Alcance", format: "int" },
  { id: "frequency", label: "Frequência", short: "Freq.", format: "ratio" },
  { id: "clicks", label: "Cliques", short: "Cliques", format: "int" },
  { id: "linkClicks", label: "Cliques no link", short: "Cliques link", format: "int" },
  { id: "ctr", label: "CTR", short: "CTR", format: "pct" },
  { id: "cpcCents", label: "CPC", short: "CPC", format: "money" },
  { id: "cpmCents", label: "CPM", short: "CPM", format: "money" },
  { id: "results", label: "Resultados", short: "Result.", format: "int" },
  {
    id: "costPerResultCents",
    label: "Custo por resultado",
    short: "Custo/result.",
    format: "money",
  },
  { id: "purchases", label: "Compras", short: "Compras", format: "int" },
  { id: "purchaseValueCents", label: "Valor de conversão", short: "Valor conv.", format: "money" },
  { id: "roas", label: "ROAS", short: "ROAS", format: "roas" },
  { id: "leads", label: "Leads", short: "Leads", format: "int" },
  { id: "costPerLeadCents", label: "Custo por lead", short: "CPL", format: "money" },
  { id: "messages", label: "Conversas", short: "Conversas", format: "int" },
  { id: "thruplays", label: "ThruPlays", short: "ThruPlays", format: "int" },
  { id: "videoP100", label: "Vídeo 100%", short: "Vídeo 100%", format: "int" },
];

export const METRIC_IDS = METRIC_DEFS.map((m) => m.id);

/** Ids das colunas de métricas na tabela de campanhas (`m:` + id da métrica). */
export const METRIC_COLUMN_PREFIX = "m:";
export function metricColumnId(id: MetricKey): string {
  return `${METRIC_COLUMN_PREFIX}${id}`;
}
export function metricOfColumn(columnId: string): MetricDef | undefined {
  if (!columnId.startsWith(METRIC_COLUMN_PREFIX)) return undefined;
  const id = columnId.slice(METRIC_COLUMN_PREFIX.length);
  return METRIC_DEFS.find((m) => m.id === id);
}
